/**
 * Vendor
 */
import React from 'react';

/**
 * CARIBE7 MODULES
 */
import BaseAlertService from '@shared/services/base/alerts/BaseAlertService';

/**
 * Question Alert Service
 *
 * @class      QuestionAlertService (name)
 */
function QuestionAlertService(component) {
  this.component   = component;
}

QuestionAlertService.prototype = Object.assign(QuestionAlertService.prototype, BaseAlertService.prototype);

/**
 * Registers Alert events, this follows naming convention
 *
 * @param      {Object}       self         The caller instance
 * @param      {BaseService}  service      The service
 * @param      {string}       module_name  The module name
 */
QuestionAlertService.prototype.registerQuestionAlertEvents = function(self, service) {
  var event_callback_map = {};
  event_callback_map[this.event_group.QUESTION_DISPLAY] = 'onQuestionDisplay';
  event_callback_map[this.event_group.QUESTION_SUCCESS] = 'onQuestionSuccess';
  event_callback_map[this.event_group.QUESTION_FAIL]    = 'onQuestionFail';
  this.registerEvents(event_callback_map, service);
  return this;
}

/**
 * Removes Alert events.
 *
 * @param      {<type>}  self         The object
 * @param      {<type>}  service      The service
 * @param      {string}  module_name  The module name
 */
QuestionAlertService.prototype.removeQuestionAlertEvents = function() {
  this.removeEvents([
    this.event_group.QUESTION_DISPLAY,
    this.event_group.QUESTION_SUCCESS,
    this.event_group.QUESTION_FAIL
  ]);
  return this;
}


/**
 * Called when success alert display
 *
 * @param      {Object}  arg1       The argument 1
 * @param      {<type>}  arg1.data  The data
 */
QuestionAlertService.prototype.onQuestionDisplay = function({
  title='Question',
  message='',
  options={},
  onConfirm,
  onResolve,
  onError
}) {
  this.createSwal({
    props: {
      title: <span>{title}</span>,
      html:  <span>{message}</span>,
      icon:  'question',
    },
    options: options,
    onConfirm: onConfirm,
    onResolve: onResolve,
    onError:   onError,
  });
};

/**
 * Called on Regsiter success.
 *
 * @param      {object}  response  The response
 */
QuestionAlertService.prototype.onQuestionSuccess = function(response) {
  console.log("QuestionAlertService::QuestionSuccess", response);
}

/**
 * Called on Regsiter fail.
 *
 * @param      {object}  error   The error
 */
QuestionAlertService.prototype.onQuestionFail = function(error) {
  console.log("QuestionAlertService::QuestionFail", error);
}

export default QuestionAlertService;